<template>
    <div>
        <div v-if="loading">
            <loading></loading>
        </div>

        <div v-else>
            <b-alert variant="danger" :show="hasErrors">
                <span v-html="errorMessage"></span>
            </b-alert>

            <!-- filter -->
            <b-row v-if="!hasErrors" class="mb-3">
                <b-col md="3" class="my-1">
                    <dead-line-filter />
                </b-col>
                <b-col md="3" class="my-1 text-center">
                </b-col>
                <b-col md="3" class="my-1">
                    <!--                    <before-filter />-->
                </b-col>
                <b-col md="3" class="my-1">
                    <b-form-group class="mb-0">
                        <b-input-group size="sm">
                            <b-form-input
                                v-model="filter"
                                placeholder="Entrer la valeur recherchée"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filter"
                                    @click="resetSearch"
                                >
                                    Effacer
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- /filter -->

            <!-- Table -->
            <b-table
                responsive
                small
                striped
                :items="filteredItems"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="['search']"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                primary-key="client_id"
                @filtered="onFiltered"
            >
                <template #cell(client.email)="data">
                    <span v-html="handleEmail(data.item.client.email)"></span>
                </template>
                <template #cell(client.history_route)="data">
                    <comments-block
                        :key="'cb' + data.item.client.id"
                        :client="data.item.client"
                        type="ten"
                    />
                </template>
                <template #cell(client.enable_time_sheets)="data">
                    <time-sheet-handler
                        :type="'ten'"
                        :client="data.item.client"
                    />
                </template>
                <template #cell(client.end_of_exercise)="data">
                    <end-of-exercise
                        :month="data.item.client.end_of_exercise"
                    ></end-of-exercise>
                </template>
                <template #cell(client.name)="data">
                    <span v-html="handleHomeRoute(data.item.client)"></span>
                </template>
                <template #cell(m1.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm1'"
                        :deadlines="data.item.m1.data"
                    />
                </template>
                <template #cell(m2.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm2'"
                        :deadlines="data.item.m2.data"
                    />
                </template>
                <template #cell(m3.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm3'"
                        :deadlines="data.item.m3.data"
                    />
                </template>
                <template #cell(m4.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm4'"
                        :deadlines="data.item.m4.data"
                    />
                </template>
                <template #cell(m5.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm5'"
                        :deadlines="data.item.m5.data"
                    />
                </template>
                <template #cell(m6.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm6'"
                        :deadlines="data.item.m6.data"
                    />
                </template>
                <template #cell(m7.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm7'"
                        :deadlines="data.item.m7.data"
                    />
                </template>
                <template #cell(m8.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm8'"
                        :deadlines="data.item.m8.data"
                    />
                </template>
                <template #cell(m9.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm9'"
                        :deadlines="data.item.m9.data"
                    />
                </template>
                <template #cell(m10.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm10'"
                        :deadlines="data.item.m10.data"
                    />
                </template>
                <template #cell(m11.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm11'"
                        :deadlines="data.item.m11.data"
                    />
                </template>
                <template #cell(m12.sort)="data">
                    <deadlines-handler
                        :key="data.item.client.id + 'm12'"
                        :deadlines="data.item.m12.data"
                    />
                </template>
            </b-table>
            <!-- /Table -->

            <!-- Pagination -->
            <b-row>
                <b-col md="3" class="my-1 text-center">
                    <b-pagination
                        v-if="totalRows > 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        class="my-0"
                        size="sm"
                    ></b-pagination>
                </b-col>
                <b-col md="6" class="my-2">
                    <p class="text-center small pt-0">{{ legend }}</p>
                </b-col>
                <b-col md="3" class="my-1 text-right">
                    <b-dropdown
                        right
                        split
                        size="sm"
                        :text="perPage + ' éléments par page'"
                    >
                        <b-dropdown-item
                            v-for="pageOption in pageOptions"
                            :key="pageOption"
                            @click="setPerPage(pageOption)"
                        >
                            {{ pageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>
            </b-row>
            <!-- /Pagination -->
        </div>
        <b-modal
            :id="'modal-time-sheet'"
            title="Saisie des temps"
            size="sm"
            hide-footer
            no-close-on-backdrop
        >
            <time-sheet-modal />
        </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import deadlinesHandler from '../components/DeadlinesHandlerNew.vue'
import loading from '../../../common/components/loading.vue'
import TableHandler from '../../../common/mixins/TableHandler.vue'
import DashboardHandler from '../../../dashboard/mixins/DashboardHandler.vue'
import DeadLineFilter from '../components/DeadLineFilter.vue'
import BeforeFilter from '../components/BeforeFilter.vue'
import TenFilter from '../components/TenFilter.vue'
import TimeSheetHandler from '../components/TimeSheetHandler.vue'
import TimeSheetModal from '../components/TimeSheetModal.vue'

export default {
    name: 'TablePrp',

    components: {
        TimeSheetHandler,
        TimeSheetModal,
        TenFilter,
        DeadLineFilter,
        BeforeFilter,
        deadlinesHandler,
        loading
    },

    mixins: [TableHandler, DashboardHandler],

    data() {
        return {
            fields: [
                {
                    key: 'client.email',
                    label: '',
                    sortable: false,
                    class: 'td-icon'
                },
                {
                    key: 'client.enable_time_sheets',
                    label: '',
                    sortable: false,
                    class: 'td-icon'
                },
                {
                    key: 'client.name',
                    label: 'Raison sociale',
                    sortable: true,
                    class: 'td-sm td-bold'
                },
                {
                    key: 'client.revision_user_initials',
                    label: 'Rév.',
                    class: 'td-sm text-center',
                    sortable: true
                },
                {
                    key: 'client.history_route',
                    label: 'Commentaires',
                    sortable: false,
                    class: 'td-sm'
                },
                {
                    key: 'client.end_of_exercise',
                    label: 'Fin exe.',
                    sortable: true,
                    class: 'td-sm text-center'
                },
                {
                    key: 'm1.sort',
                    label: 'jan',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm2.sort',
                    label: 'fév',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm3.sort',
                    label: 'mar',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm4.sort',
                    label: 'avr',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm5.sort',
                    label: 'mai',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm6.sort',
                    label: 'jun',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm7.sort',
                    label: 'jul',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm8.sort',
                    label: 'aou',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm9.sort',
                    label: 'sep',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm10.sort',
                    label: 'oct',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm11.sort',
                    label: 'nov',
                    sortable: true,
                    class: ' td-deadlines-3'
                },
                {
                    key: 'm12.sort',
                    label: 'déc',
                    sortable: true,
                    class: ' td-deadlines-3'
                }
            ],
            allItems: []
        }
    },

    computed: {
        ...mapState({
            activationFilter: (state) => state.browsing.clientsActivationFilter
        })
    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'prp')
        this.getItems()
        this.$store.commit(
            'timeSheetsVM/SET_CURRENT_DATE',
            this.$moment().format('Y-MM-DD')
        )
        this.$store.commit('timeSheetsVM/SET_PAGE_CODE', 'prp')
    },

    methods: {
        async getItems() {
            try {
                this.loading = true
                const response = await axios.get(
                    `/reporting/get-data/optimized/prp/${this.year}`
                )
                this.items = response.data.data
                this.filterItems()
                this.loading = false
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        async getUpdatedItem(client_id, month) {
            try {
                const response = await axios.get(
                    `/reporting/get-data/optimized/prp/${this.year}/${client_id}`
                )
                this.updatedItem = response.data.data[0]
                this.updateMonthData(client_id, month)
            } catch (error) {
                console.log(error)
                this.handleErrors(error.response)
            }
        },

        filterItems() {
            console.log('filterItems')
            switch (this.activationFilter) {
                case 'active':
                    this.items = this.items.filter(
                        (item) => item.client.is_active
                    )
                    break
                case 'old':
                    this.items = this.items.filter(
                        (item) => !item.client.is_active
                    )
                    break
                default:
                    break
            }
            this.updateTotalRows()
        }
    }
}
</script>
<style></style>
